import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import { FormattedDate, FormattedMessage } from 'react-intl';

import { Spinner } from 'admin-components/components';
import { Column, Row } from 'components/shared/Layout';
import AgentPortalError from 'errors/AgentPortalError';
import Message from 'pages/LiveTravelInformation/Message';
import Train from 'pages/LiveTravelInformation/Train';
import { TIMETABLE_NEWS_BY_ID } from 'store/queries';

import { groupAffectedServicesByDate } from './TravelUpdates.utils';
import { StyledAffectedTrains, StyledContainer, StyledDateHeading, StyledWarningDetails } from './TravelUpdates.styles';

const TravelUpdates = ({ match: { params } }) => {
  const { data, error, loading } = useQuery(TIMETABLE_NEWS_BY_ID, {
    variables: { id: params.id }
  });

  if (error) {
    throw new AgentPortalError(error);
  }

  const travelUpdate = data?.timetableNewsById;
  const affectedServicesByDate = groupAffectedServicesByDate(travelUpdate?.services);

  return (
    <StyledContainer>
      <h1>
        <FormattedMessage id="travelUpdates.title" />
      </h1>
      {loading ? (
        <Row span={16} height="100vh">
          <Column justifyContent="center" alignItems="center">
            <Spinner />
          </Column>
        </Row>
      ) : (
        travelUpdate && (
          <>
            <StyledWarningDetails>
              <Message {...travelUpdate.model} alert />
            </StyledWarningDetails>
            {affectedServicesByDate.map(({ date, services }) => (
              <section data-testid={`affected-services-${date}`} key={date}>
                <StyledDateHeading>
                  <FormattedDate value={new Date(`${date}T00:00:00`)} day="numeric" month="short" year="numeric" />
                </StyledDateHeading>
                <StyledAffectedTrains>
                  {services.map((service) => (
                    <Train key={service.model.serviceName} {...service} />
                  ))}
                </StyledAffectedTrains>
              </section>
            ))}
          </>
        )
      )}
    </StyledContainer>
  );
};

TravelUpdates.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired
    }).isRequired
  }).isRequired
};

export default TravelUpdates;
